import { render, staticRenderFns } from "./TicketBody.vue?vue&type=template&id=da160d9a&scoped=true&"
import script from "./TicketBody.vue?vue&type=script&lang=js&"
export * from "./TicketBody.vue?vue&type=script&lang=js&"
import style0 from "./TicketBody.vue?vue&type=style&index=0&id=da160d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da160d9a",
  null
  
)

export default component.exports